/* CPPerformance — primary pages + custom exhaust funnel */
(function(){
  function el(html){const t=document.createElement('template');t.innerHTML=html.trim();return t.content.firstElementChild;}
  function path(){return location.pathname.replace(/\/+$/,'')||'/';}
  function home(){return document.querySelector("main[data-template='index']");}
  function montage(){return document.getElementById('montage-afspraak');}
  function norm(value){return String(value||'').toLowerCase().trim().replace(/\s+/g,' ');}
  function sectionByHeading(main,needle){
    if(!main)return null;
    const heading=Array.from(main.querySelectorAll('h1,h2,h3')).find(function(node){return norm(node.textContent).indexOf(norm(needle))>-1;});
    return heading?(heading.closest('.shopify-section')||heading.parentElement):null;
  }
  function apexSection(main){
    if(!main)return null;
    const hit=main.querySelector("[id*='apex_feature']");
    if(hit)return hit.classList.contains('shopify-section')?hit:(hit.closest('.shopify-section')||hit);
    return sectionByHeading(main,'APEX AERO DESIGN');
  }

  function placeHomepageFunnel(){
    const m=home();
    if(!m)return;
    const full=document.querySelector('[data-cp-custom-exhaust-full]');
    const mont=montage();
    const apex=apexSection(m);
    const reviews=sectionByHeading(m,'Meer dan 1000 tevreden klanten');
    if(!full||!mont||!apex||!reviews)return;

    /* Keep one stable conversion sequence: Bestsellers → Montage → APEX → Custom → Reviews. */
    if(mont.nextElementSibling!==apex)mont.insertAdjacentElement('afterend',apex);
    if(apex.nextElementSibling!==full)apex.insertAdjacentElement('afterend',full);
    if(full.nextElementSibling!==reviews)full.insertAdjacentElement('afterend',reviews);

    apex.classList.add('cp-apex-after-montage');
    full.classList.add('cp-custom-exhaust-full--home');
    reviews.classList.add('cp-reviews-after-custom');

    /* Remove the old large empty gap and let APEX visually connect to Montage. */
    full.style.setProperty('margin-top','0','important');
    const apexShell=apex.querySelector('.layered-slideshow-section');
    if(apexShell){
      apexShell.style.setProperty('padding-top','10px','important');
      apexShell.style.setProperty('padding-bottom','24px','important');
    }
  }

  function customPage(){
    if(path()!=='/pages/custom-uitlaatsystemen')return;
    const m=document.querySelector("main[data-template^='page']");
    const full=document.querySelector('[data-cp-custom-exhaust-full]');
    if(!m||!full)return;
    m.classList.add('cp-custom-page');

    let hero=m.querySelector('.cp-custom-page-hero');
    if(!hero){
      hero=el('<section class="cp-custom-page-hero"><div><span>CPPerformance maatwerk</span><h1>Custom uitlaatsystemen</h1><p>Een uitlaat op maat voor jouw gewenste sound, uitstraling en rijbeleving. Van subtiel sportief tot volledig custom.</p><a href="#custom-aanvraag">Start jouw aanvraag →</a></div></section>');
      m.insertAdjacentElement('afterbegin',hero);
    }

    Array.from(m.children).forEach(function(child){
      if(child!==hero&&child!==full)child.classList.add('cp-custom-page__legacy');
    });

    if(hero.nextElementSibling!==full)hero.insertAdjacentElement('afterend',full);
    full.classList.remove('cp-custom-exhaust-full--home');
    full.style.removeProperty('margin-top');
  }

  function assortment(){
    if(path()!=='/collections/all')return;
    const m=document.querySelector("main[data-template^='collection']");
    if(!m||m.querySelector('.cp-assortment-depth'))return;
    m.classList.add('cp-assortment-page');
    const h=m.querySelector('h1');
    const host=h&&(h.closest('.shopify-section')||h.parentElement);
    if(!host)return;
    host.insertAdjacentElement('afterend',el('<section class="cp-assortment-depth"><div class="cp-assortment-depth__intro"><span>CPPerformance assortiment</span><h2>Vind jouw volgende upgrade.</h2><p>Shop direct per categorie of kies voor maatwerk wanneer je iets unieks wilt laten maken.</p></div><div class="cp-assortment-depth__grid"><a href="/collections/uitlaat-systemen"><b>Uitlaatsystemen</b><small>Sportuitlaten en uitlaatdelen →</small></a><a href="/collections/downpipe"><b>Downpipes</b><small>Bekijk de beschikbare uitvoeringen →</small></a><a href="/collections/middendemper-delete"><b>Middendemper delete</b><small>Meer sound met een gerichte upgrade →</small></a><a href="/collections/bodykits"><b>Bodykits & styling</b><small>Diffusers, lips en meer →</small></a><a href="/collections/bestsellers"><b>Bestsellers</b><small>Veelgekozen upgrades →</small></a><a class="cp-assortment-depth__custom" href="/pages/custom-uitlaatsystemen"><b>Custom uitlaatsysteem</b><small>Laat jouw eigen setup samenstellen →</small></a></div><div class="cp-assortment-depth__help"><strong>Hulp nodig bij kiezen?</strong><span>Stuur ons je auto en wensen, dan denken we gericht met je mee.</span><a href="/pages/contact">Vraag advies →</a></div></section>'));
  }

  function contact(){
    if(path()!=='/pages/contact')return;
    const m=document.querySelector("main[data-template^='page']");
    if(!m||m.querySelector('.cp-contact-depth'))return;
    m.classList.add('cp-contact-page');
    const first=m.firstElementChild;
    if(!first)return;
    first.insertAdjacentElement('afterend',el('<section class="cp-contact-depth"><div class="cp-contact-depth__head"><span>Persoonlijk geholpen</span><h2>Waar kunnen we je mee helpen?</h2><p>Voor productadvies, montage of maatwerk kun je direct contact opnemen. Vermeld je auto en wensen, dan kunnen we sneller gericht reageren.</p></div><div class="cp-contact-depth__grid"><article><b>Productadvies</b><p>Hulp bij het kiezen van de juiste upgrade of uitvoering.</p></article><article><b>Montage</b><p>Montage is mogelijk op afspraak bij CPPerformance in Nederweert.</p><a href="/#montage-afspraak">Montage aanvragen →</a></article><article class="cp-contact-depth__accent"><b>Custom uitlaatsysteem</b><p>Voor een eigen sound, RVS maatwerk, klepopties of specifieke afwerking.</p><a href="/pages/custom-uitlaatsystemen#custom-aanvraag">Start custom aanvraag →</a></article></div><div class="cp-contact-depth__location"><span><strong>CPPerformance</strong>Platinastraat 6D<br>6031 TW Nederweert</span><span><strong>Werkplaats</strong>Montage en maatwerk op afspraak.</span></div></section>'));
  }

  function navDepth(){
    document.querySelectorAll('#header-group a[href="/"],#header-group a[href="/collections/all"],#header-group a[href*="/pages/contact"],#header-group a[href*="/pages/custom-uitlaatsystemen"]').forEach(function(a){
      a.classList.add('cp-primary-nav-link');
      if(a.getAttribute('href').indexOf('/pages/custom-uitlaatsystemen')>-1)a.classList.add('cp-primary-nav-link--custom');
    });
  }

  function all(){placeHomepageFunnel();customPage();assortment();contact();navDepth();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(){setTimeout(all,0)});
  const o=new MutationObserver(function(){clearTimeout(o.t);o.t=setTimeout(all,160)});
  o.observe(document.documentElement,{childList:true,subtree:true});
})();

